module.exports = __webpack_public_path__ + "img/tws5.6b1f3373.png";